export default __webpack_public_path__ + "static/media/cash.759f505c.png";